import {FCX} from "@datassential/platform-ui-lib";
import {iMainMetric} from "@models/Filter";
import {ID, Timeframe, UnitType} from "@models";
import React, {Dispatch, memo, SetStateAction} from "react";
import HeaderBar from "@components/HeaderBar";
import Select from "@components/Select";
import ButtonTabs from "@components/ButtonTabs";
import cn from "classnames";

const AnalyzePerformanceHeaderBar: FCX<{
    mainMetrics: iMainMetric[],
    selectedUnit: UnitType,
    selectedPeriod: Timeframe,
    selectedMetricId: ID,
    setSelectedPeriod: Dispatch<SetStateAction<Timeframe>>,
    setSelectedMetricId: Dispatch<SetStateAction<ID>>,
    title: string,
}> = ({
    mainMetrics,
    className,
    selectedUnit,
    selectedPeriod,
    selectedMetricId,
    setSelectedPeriod,
    setSelectedMetricId,
    title
}) => {
    return (
        <HeaderBar
            className={
                cn(
                    "AnalyzePerformanceHeaderBar",
                    className
                )
            }
        >
            <div className="AnalyzePerformanceHeaderBar__title-container">
                <div className="font-medium">
                    {title}: Historic Trend
                </div>
            </div>
            <div className="AnalyzePerformanceHeaderBar__select-container">
                {selectedUnit === UnitType.Count ? 'New launches by' : (
                    <>
                        average&nbsp;
                        <Select
                            options={mainMetrics}
                            value={[selectedMetricId]}
                            closeOnOptionClick
                            className="AnalyzePerformanceHeaderBar__select-metric AnalyzePerformanceSelectMetric"
                            onOptionClick={setSelectedMetricId}
                        />
                        &nbsp;&nbsp;by
                    </>
                )}
                <ButtonTabs
                    className="AnalyzePerformanceHeaderBar__button-tabs"
                    data={[
                        {
                            id: Timeframe.Season,
                            title: 'Season',
                            buttonProps: {
                                onClick: () => setSelectedPeriod(Timeframe.Season),
                            }
                        },
                        {
                            id: Timeframe.Year,
                            title: 'Year',
                            buttonProps: {
                                onClick: () => setSelectedPeriod(Timeframe.Year),
                            }
                        },
                    ]}
                    activeItemId={selectedPeriod}
                />
            </div>
        </HeaderBar>
    )
}


export default memo(AnalyzePerformanceHeaderBar);